/**
 * Entry point for the CD additional-information form module.
 *
 * Called by the main lead-tracker bootstrap (unified-lead-tracker.ts) on
 * DOMContentLoaded, after the session has been initialized and the component
 * renderer has been wired up.
 *
 * No-op for non-CreditDirect pages — the module only activates when the
 * host element is present in the DOM.
 */

export { AdditionalInfoFormController } from './form-controller';
export { ADDITIONAL_INFO_FIELDS } from './field-schema';
export type {
  AdditionalInfoFormConfig,
  AdditionalInfoSubmitResponse,
} from './types';

import { AdditionalInfoFormController } from './form-controller';
import type { AdditionalInfoFormConfig } from './types';

let singleton: AdditionalInfoFormController | null = null;

export function initAdditionalInfoForm(
  config: AdditionalInfoFormConfig
): AdditionalInfoFormController {
  if (singleton) return singleton;
  singleton = new AdditionalInfoFormController(config);
  singleton.init();
  return singleton;
}

